import { atom } from 'jotai';

export const openLogRequestModalAtom = atom(false);
